// 2026-08-23 — Employee-first identity. A login is a switch on an employee
// record, never a standalone account. This pure helper describes the row cell
// so EmployeesPage.tsx (700+ lines) has a testable seam.

export interface EmployeeLoginCell {
  label: string;
  tone: 'on' | 'off' | 'none';
}

/**
 * Login state fetched from GET /api/v1/employees/:id/login.
 * `null` means the caller is not allowed to see it (403 from
 * requireCompensationRole) — the drawer renders no switch in that case.
 */
export interface EmployeeLoginState {
  hasLogin: boolean;
  isActive: boolean;
  canOnboard: boolean;
  blockedReason: string | null;
  defaultRoleName: string | null;
}

/** Describe an employee's login state for the Employees table cell. */
export function describeLoginCell(emp: {
  user?: { id: string; isActive: boolean } | null;
}): EmployeeLoginCell {
  if (!emp.user) return { label: 'No login', tone: 'none' };
  return emp.user.isActive
    ? { label: 'Login on', tone: 'on' }
    : { label: 'Login off', tone: 'off' };
}
